/* eslint-disable max-len */

define(function() {
    'use strict';
    var origin = 'api.tomtom.com';
    return {
        'mapboxgl.version': '0.50.0',
        'sdk.version': '4.45.7',
        'analytics.header.name': 'TomTom-User-Agent',
        'analytics.header.sdkName': 'MapsWebSDK',
        'origin': origin,

        // copyrights
        'endpoints.copyrightsWorld': origin + '/map/1/copyrights.{contentType}',
        'endpoints.copyrightsBounds': origin + '/map/1/copyrights/{minLon}/{minLat}/{maxLon}/{maxLat}.{contentType}',
        'endpoints.caption': origin + '/map/1/copyrights/caption.{contentType}',

        // search
        'endpoints.geocode': origin + '/search/2/geocode/{query}.{contentType}',
        'endpoints.batchGeocodeQuery': '/geocode/{query}.{contentType}',
        'endpoints.structuredGeocode': origin + '/search/2/structuredGeocode.{contentType}',
        'endpoints.batchStructuredGeocodeQuery': '/structuredGeocode.{contentType}',
        'endpoints.search': origin + '/search/2/{type}/{query}.{contentType}',
        'endpoints.batchSearch': origin + '/search/2/batch.{contentType}',
        'endpoints.batchSyncSearch': origin + '/search/2/batch/sync.{contentType}',
        'endpoints.batchSearchQuery': '/{type}/{query}.{contentType}',
        'endpoints.adp': origin + '/search/2/additionalData.{contentType}',
        'endpoints.reverseGeocode': origin + '/search/2/{type}/{position}.{contentType}',
        'endpoints.batchReverseGeocodeQuery': '/{type}/{position}.{contentType}',

        // traffic
        'endpoints.trafficIncidents': origin + '/traffic/services/4/incidentDetails/{style}/{minLat},{minLon},{maxLat},{maxLon}/{zoom}/{trafficModelID}/{contentType}',
        'endpoints.trafficViewport': origin + '/traffic/services/4/incidentViewport/0,0,.1,.1/0/0,0,.1,.1/0/false/{contentType}',
        'endpoints.flowSegmentData': origin + '/traffic/services/4/flowSegmentData/{style}/{zoom}/{contentType}',
        'endpoints.incidentRegions': origin + '/traffic/services/4/incidentRegions/{contentType}',

        // layers
        'endpoints.trafficLayer': '{s}.' + origin + '/traffic/map/4/tile/incidents/{style}/{z}/{x}/{y}.png',
        'endpoints.trafficFlowLayer': '{s}.' + origin + '/traffic/map/4/tile/flow/{style}/{z}/{x}/{y}.png',
        'endpoints.tileLayer': '{s}.' + origin + '/map/1/tile/{layer}/{style}/{z}/{x}/{y}.png',

        // routing
        'endpoints.routing': origin + '/routing/1/calculateRoute/{locations}/{contentType}',
        'endpoints.reachableRange': origin + '/routing/1/calculateReachableRange/{origin}/{contentType}',
        'endpoints.batchRouting': origin + '/routing/1/batch/{contentType}',
        'endpoints.batchSyncRouting': origin + '/routing/1/batch/sync/{contentType}',
        'endpoints.batchRoutingQuery': '/calculateRoute/{locations}/{contentType}',
        'endpoints.batchReachableRangeQuery': '/calculateReachableRange/{origin}/{contentType}',
        'endpoints.matrixRouting': origin + '/routing/1/matrix/{contentType}',
        'endpoints.matrixSyncRouting': origin + '/routing/1/matrix/sync/{contentType}',

        //static map image
        'endpoints.staticMapImage': 'https://' + origin + '/map/1/staticimage',

        'vector.glyphs': 'https://' + origin + '/maps-sdk-js/4.45.7/glyphs/{fontstack}/{range}.pbf',
        'vector.sprites': 'https://' + origin + '/maps-sdk-js/4.45.7/sprites/sprite'
    };
});




// WEBPACK FOOTER //
// /home/ubuntu/jenkins/workspace/rp_start_release_npm/jssdk/build/mainConfig.js